module.exports = __webpack_public_path__ + "img/542.4744a3ea.jpg";